export default "__VITE_ASSET__BMHU$yR0__"